import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CustomValidator, validateInput } from '@shared/services/custom-validatior.abstract';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {CommonFunctions} from '@shared/common-functions'
interface SpecialRate {
  spotTypeId: string;
  code: string;
  monthlyRate: string;
  dailyRate: string;
  description: string;
}

@Component({
  selector: 'app-custom-rates-popup',
  templateUrl: './custom-rates-popup.component.html',
  styleUrls: ['./custom-rates-popup.component.scss']
})
export class CustomRatesPopupComponent implements OnInit{
  spotTypeId: any;
  specialRateForm: FormGroup;
  specialRate: SpecialRate[] = [];
  isEditMode: boolean = false;
  existingRate: SpecialRate;
  editIndex: number;
  dailyRate: number;
  monthlyRate: number;

  constructor(private readonly ref: DynamicDialogRef,
    private readonly fb: FormBuilder,
    private readonly config: DynamicDialogConfig) { }

  ngOnInit() {
    this.spotTypeId = this.config.data.SpotTypeId;
    this.editIndex = this.config.data.editIndex;
    this.dailyRate = this.config.data.dailyRate;
    this.monthlyRate = this.config.data.monthlyRate;
    this.initializeForm()
    if (this.config.data.exsistingRecord) {
      this.existingRate = this.config.data.exsistingRecord;
      this.isEditMode = true;
      this.populateForm(this.existingRate);
    }
  }

  initializeForm() {
    this.specialRateForm = this.fb.group({
      spotTypeId: [this.spotTypeId, Validators.required],
      code: ['', [Validators.required, Validators.minLength(3)]],
      monthlyRate: ['', [Validators.required, CustomValidator.validateGreaterThanZero]],
      dailyRate: ['', [Validators.required, CustomValidator.validateGreaterThanZero]],
      description: ['', [Validators.required, Validators.minLength(3), this.noHtmlValidator()]]
    })
  }
  close() {
    this.ref.close();
  }
  save() {
    
    if (this.specialRateForm.valid) {
      this.specialRate.push(this.specialRateForm.value);
      this.ref.close({ specialRate: this.specialRate, editIndex: this.editIndex });
      
    }
    else {
      CustomValidator.markFormGroupTouched(this.specialRateForm)
    }
  }

  onKeyPressAllowTwoDigitAfterPoint(event: KeyboardEvent): void {
    if (!validateInput(event)) {
      event.preventDefault();
    }
  }

  preventFirstSpace(event: KeyboardEvent) {
      CommonFunctions.preventFirstSpaces(event);
    }

  populateForm(rate: SpecialRate) {
    this.specialRateForm.patchValue({
      spotTypeId: rate.spotTypeId,
      code: rate.code,
      monthlyRate: rate.monthlyRate,
      dailyRate: rate.dailyRate,
      description: rate.description
    });
  }

  noHtmlValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      if (typeof val !== 'string') {
        return null;
      }
      const htmlTagPattern = /<[^>]+>/g;
      if (htmlTagPattern.test(val)) {
        return { containsHtml: true };
      }
      return null;
    };
  }
}
